import { Component, computed, input, model } from '@angular/core';
import { type ButtonGroupColor, type ButtonGroupOption, type ButtonGroupSize } from './btn-group.model';

@Component({
  selector: 'lib-button-group',
  styleUrls: [
    '../../tokens/colors.css',
    '../../tokens/btn-group-tokens.css',
    './btn-group.component.css',
  ],
  templateUrl: './btn-group.component.html',
  host: {
    'role': 'radiogroup',
    '[class]': 'hostClasses()',
  },
})
export class ButtonGroupComponent {
  readonly options = input.required<ButtonGroupOption[]>();
  readonly value = model<string>('');
  readonly color = input<ButtonGroupColor>('emerald');
  readonly size = input<ButtonGroupSize>('md');

  readonly hostClasses = computed(() => ({
    [`msa-btn-group--${this.size()}`]: true,
    [`msa-btn-group--${this.color()}`]: true,
  }));

  selectOption(optionValue: string): void {
    this.value.set(optionValue);
  }
}
